import React, { useState, useEffect, useCallback } from 'react';
import LoginForm from './LoginForm';
import SignupForm from './SignupForm';
import '../styles/AuthModal.css';

function AuthModal({ initialTab = 'login', onClose }) {
  const [activeTab, setActiveTab] = useState(initialTab);

  const handleKeyDown = useCallback((e) => {
    if (e.key === 'Escape') onClose();
  }, [onClose]);

  useEffect(() => {
    document.addEventListener('keydown', handleKeyDown);
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
      document.body.style.overflow = '';
    };
  }, [handleKeyDown]);

  // Only close when the press *starts and ends* on the backdrop itself.
  // Without tracking the mousedown target, highlighting text inside a field
  // and releasing the drag outside it fires a click on the backdrop and
  // wrongly closes the modal.
  const backdropMouseDown = React.useRef(false);

  const handleBackdropMouseDown = (e) => {
    backdropMouseDown.current = e.target === e.currentTarget;
  };

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget && backdropMouseDown.current) onClose();
    backdropMouseDown.current = false;
  };

  return (
    <div
      className="auth-modal-backdrop"
      onMouseDown={handleBackdropMouseDown}
      onClick={handleBackdropClick}
    >
      <div className="auth-modal" role="dialog" aria-modal="true">
        <button className="auth-modal-close" onClick={onClose} aria-label="Close">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
          </svg>
        </button>

        <div className="auth-tabs">
          <button
            className={`auth-tab ${activeTab === 'login' ? 'active' : ''}`}
            onClick={() => setActiveTab('login')}
          >
            Log In
          </button>
          <button
            className={`auth-tab ${activeTab === 'signup' ? 'active' : ''}`}
            onClick={() => setActiveTab('signup')}
          >
            Sign Up
          </button>
        </div>

        {activeTab === 'login' ? (
          <LoginForm onSwitchToSignup={() => setActiveTab('signup')} />
        ) : (
          <SignupForm onSwitchToLogin={() => setActiveTab('login')} />
        )}
      </div>
    </div>
  );
}

export default AuthModal;
